module.exports = __webpack_public_path__ + "img/touxiang.287d982f.jpg";